import { BrandLogo } from "./BrandLogo";
import "./RouteLoadingState.css";

export function RouteLoadingState() {
  return (
    <div className="studio-loading studio-theme" role="status" aria-live="polite">
      <BrandLogo compact />
      <h1>Opening your workspace</h1>
      <p>Getting the studio ready.</p>
      <span className="studio-loading__track" aria-hidden="true" />
    </div>
  );
}
